export default __webpack_public_path__ + "media/zurb/img/legacy/clue/instructions-5-db3df9e6da62eb40fa14821fa630a531.jpg";